import { LessonCard } from "./LessonCard";
import { groupByMonth } from "./calendarUtils";

export const ListView = ({ lessons, colors, overlaps, onOpen }) => (
  <div data-testid="cal-list" className="space-y-5">
    {lessons.length === 0 ? <p className="text-sm text-muted-foreground" data-testid="cal-list-empty">Nessuna lezione in questo mese.</p>
      : groupByMonth(lessons).map((g) => (
        <div key={g.key} data-testid={`cal-list-month-${g.key}`}>
          <h4 className="text-sm uppercase tracking-wide text-muted-foreground mb-2">{g.label} <span className="normal-case">· {g.items.filter((x) => x.status !== "cancelled").length} lezioni</span></h4>
          <div className="space-y-2">
            {g.items.map((x) => <LessonCard key={x.id} x={x} color={colors[x.course]} overlap={overlaps.has(x.id)} onOpen={onOpen} />)}
          </div>
        </div>
      ))}
  </div>
);
